// extracted by mini-css-extract-plugin
module.exports = {"container":"_eadd6e2","green":"_be345e4","active":"_042d106","yellow":"_55f05b7","magenta":"_305d36a","purple":"_fa836c8","blue":"_fd16018"};